import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
    selector: "app-user-profile-action-buttons",
    templateUrl: "./user-profile-action-buttons.component.html",
    styleUrls: ["./user-profile-action-buttons.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileActionButtonsComponent {
    @Input() isOnEdit: boolean
    @Input() isDisabled: boolean
    @Output() isCancelClicked = new EventEmitter<boolean>()
    @Output() isEditClicked = new EventEmitter<boolean>()

    cancelChanges(): void {
        this.isCancelClicked.emit(true)
    }

    toggleEditForm(): void {
        this.isEditClicked.emit(true)
    }
}
